import React from 'react';
import JourneyRow from './JourneyRow';

const JourneyTableBody = ({ data, lastFetched, selectedContentType }) => (
  <div className="Content-tableBody Table-body">
    {data.map((content, i) => (
      <JourneyRow
        key={`journey_row_${content.id}`}
        index={i}
        {...content}
        selectedContentType={selectedContentType}
      />
    ))}
  </div>
);

export default JourneyTableBody;
